import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { useGetYampiAuthorizationUrlLazyQuery } from 'src/graphql/generated';

import Image from 'src/components/image';

// ----------------------------------------------------------------------

type Props = {
  open: boolean;
  onClose: () => void;
  isConnected: boolean;
  merchantAlias?: string | null;
};

// ----------------------------------------------------------------------

export function ConfigYampiModal({ open, onClose, isConnected, merchantAlias }: Props) {
  const [getAuthorizationUrl, { loading }] = useGetYampiAuthorizationUrlLazyQuery();

  const handleConnect = async () => {
    const { data } = await getAuthorizationUrl();
    const result = data?.getYampiAuthorizationUrl;
    if (!result) return;

    sessionStorage.setItem('yampi_code_verifier', result.codeVerifier);
    sessionStorage.setItem('yampi_state', result.state);

    window.location.href = result.url;
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Stack alignItems="center" pt={3}>
        <Image src="/assets/images/yampi-logo.svg" width={60} />
      </Stack>

      <DialogTitle textAlign="center" fontSize={20}>
        Integração Yampi
      </DialogTitle>

      {isConnected ? (
        <>
          <DialogContent sx={{ minWidth: { xs: 360, md: 400 }, textAlign: 'center' }}>
            <Typography color="success.main" fontWeight={600}>
              Conectado
            </Typography>
            {merchantAlias && (
              <Typography variant="body2" color="text.secondary" mt={1}>
                Loja: {merchantAlias}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" color="inherit" onClick={onClose}>
              Fechar
            </Button>
          </DialogActions>
        </>
      ) : (
        <>
          <DialogContent
            sx={{
              pb: 4,
              px: 5,
              minWidth: 280,
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
              color: 'text.secondary',
            }}
          >
            Clique em &quot;Conectar&quot; para autorizar o acesso à sua loja Yampi. Você será
            redirecionado para a página de autorização da Yampi.
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" color="inherit" onClick={onClose}>
              Cancelar
            </Button>
            <Button variant="contained" color="primary" disabled={loading} onClick={handleConnect}>
              Conectar Yampi
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
